module.exports = __webpack_public_path__ + "static/img/哆啦A梦模型.a5094e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/哆啦A梦模型.jpg
// module id = rcL8
// module chunks = 1